import { ChecklistStatus } from '../../common/DocPage.types';

export const DividerStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.unknown,
  markupSupport: ChecklistStatus.unknown,
  highContrastSupport: ChecklistStatus.unknown,
  rtlSupport: ChecklistStatus.pass,
  testCoverage: ChecklistStatus.unknown
};
